/**
 * Component to manage conditional rendering of children  based on condition
 *
 * @param {boolean} [condition = true] condition to render children
 * @param {React.ReactNode} children children to render if condition is true
 *
 * @returns {React.ReactNode} - The rendered children or null.
 *
 * @example
 * <RenderIf condition={true}>
 *   <div>Hello World</div>
 * </RenderIf>
 */

export default function RenderIf({ children, condition = true }) {
  return condition && children;
}
